"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFlightFilled = function IconFlightFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "flight"), _react.default.createElement("path", {
    d: "M42.67,20.94a1.29,1.29,0,1,1-.74-2.48l3-.91a15.57,15.57,0,0,0-3.83-.47,16.21,16.21,0,0,0-5.58,1l-4.92,1.78a2.76,2.76,0,0,1-1.94,0L16.06,15h-.12l-2.67.89a.2.2,0,0,0-.09.31l6.53,7.64a1.35,1.35,0,0,1-.4,2.07l-7.61,4a.67.67,0,0,1-.72-.07L6,26.06a.17.17,0,0,0-.17,0l-2.67.9a.18.18,0,0,0-.11.26c.49,1,2.93,6.24,4,8A3.83,3.83,0,0,0,10.94,37l8.42-1.51A19.76,19.76,0,0,0,24,34l16.67-6.89a10.8,10.8,0,0,0,6.26-7l0-.07a1.45,1.45,0,0,0,.06-.41ZM31.54,25.72a.47.47,0,0,1-.63-.26l-.75-1.79a.47.47,0,0,1,.26-.63.43.43,0,0,1,.19,0,.46.46,0,0,1,.44.3l.75,1.79A.47.47,0,0,1,31.54,25.72Zm3.58-1.5a.47.47,0,0,1-.63-.26l-.75-1.79a.47.47,0,0,1,.26-.63.41.41,0,0,1,.19,0,.47.47,0,0,1,.44.3l.75,1.79A.47.47,0,0,1,35.12,24.22Zm3.58-1.5a.47.47,0,0,1-.63-.26l-.75-1.79a.47.47,0,0,1,.26-.63.41.41,0,0,1,.19,0,.47.47,0,0,1,.44.3L39,22.09A.47.47,0,0,1,38.7,22.72Z",
    fill: color
  }));
};

IconFlightFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconFlightFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconFlightFilled;
exports.default = _default;